import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreInvoicePrinter, getStoreLocalData, getUserData } from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import { Button } from "primereact/button";
import AdminMenu from "../AdminMenu";
import ButtonLink from "../../ButtonLink";

// import qz from "qz-tray";

const StoreReportCollectionReceipt = () => {

  const { storeData, userProfileRole, brandProfileData } = getUserData();
  
  let store = storeData;
  let brand = brandProfileData;
  const storeId = storeData.id;
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const { storeLocalData } = getStoreLocalData();

  const location = useLocation();
  const {
    filteredDataInvoice,
    filteredDataPackage,
    filteredDataWallet,
    statusTotalData,
    statusTotalPackageData,
    statusTotalWalletData,
    allTotalData,
    searchFilterValue,
    storeNameData,
    receiptDate
  } = location.state || {}; // Fallback to prevent undefined errors

  const navigate = useNavigate();


  const [visible, setVisible] = useState(false);
  // const [isConnected, setIsConnected] = useState(false);

  const StoreName = storeNameData ? storeNameData :   store.storeName

  // const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  // const fetchSelectedInvoicePrinter = async () => {
  //   try {
  //     const selectedInvoicePrinterData = await getStoreInvoicePrinter();
  //     setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
  //   } catch {
  //     setInvoicePrinterValue("");
  //   }
  // };

  // useEffect(() => {
  //   if (!isConnected) {
  //     connectToQZ();
  //   }

  //   fetchSelectedInvoicePrinter();
  // }, []);

  // const connectToQZ = async () => {
  //   try {
  //     if (!qz.websocket.isActive()) {
  //       await qz.websocket.connect();
  //       setIsConnected(true);
  //     }
  //   } catch (err) {
  //     console.error("Connection error:", err);
  //   }
  // };

  // const printHTML = async () => {
    // try {
    //   const printer = await qz.printers.find(invoicePrinterValue);
    //   const config = qz.configs.create(printer, {
    //     encoding: "UTF-8",
    //     size: { width: 3 },
    //     units: "in",
    //     density: "600",
    //     colorType: "grayscale",
    //   });
    //   // Generate the items HTML separately
    //   const itemsHtml = orderItems2
    //     .map((orderItem) => {
    //       const itemList = Object.values(orderItem.itemMap || {});
    //       const deliveryDate = new Date(
    //         orderItem.orderDTO.deliveryOn
    //       ).toLocaleString("en-GB", {
    //         day: "2-digit",
    //         month: "2-digit",
    //       });
    //       return itemList
    //         .flatMap((obj, idx) => {
    //           const garmentLines = obj.garmentName
    //             .replace(/_/g, " ")
    //             .match(/.{1,20}/g) || [""];
    //           const jobText = obj.serviceName.replace(/,/g, ", ");
    //           const jobLines = jobText.match(/.{1,15}/g) || [""];
    //           const maxLines = Math.max(garmentLines.length, jobLines.length);
    //           return Array.from({ length: maxLines }, (_, lineIdx) => {
    //             const showFirstLine = idx === 0 && lineIdx === 0;
    //             return `
    //           <div style="display: flex;">
    //             <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${
    //               showFirstLine ? orderItem.orderDTO.invoiceNo : ""
    //             }</p>
    //             <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${
    //               lineIdx === 0 ? obj.itemCount : ""
    //             }</p>
    //             <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${
    //               garmentLines[lineIdx] || ""
    //             }</p>
    //             <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${
    //               jobLines[lineIdx] || ""
    //             }</p>
    //             <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${
    //               showFirstLine ? deliveryDate : ""
    //             }</p>
    //           </div>
    //         `;
    //           }).join("");
    //         })
    //         .join("");
    //     })
    //     .join("");
    //   // Now complete HTML
    //   const htmlContent = `
    //     <html>
    //       <body style="font-size: 12px; font-family: sans-serif;">
    //         <div style="text-align: center;">
    //           <span style="font-size: 18px; font-weight: bold;">Challan</span>
    //           <hr style="border-top: 1px dashed #000;"/>
    //           <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
    //           <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
    //           <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
    //           <p style="font-size: 12px; margin: 0;">${data.email}</p>
    //           <hr style="border-top: 1px dashed #000;"/>
    //           <p style="font-size: 14px; font-weight: bold; margin: 0;">Challan Number : ${item.challanNumber}</p>
    //           <p style="font-size: 14px; font-weight: bold; margin: 0;">Challan To : ${item.challanTo}</p>
    //           <p style="font-size: 14px; font-weight: bold; margin: 0;">Driver Detail  : ${item.driverDetail}</p>
    //           <p style="font-size: 14px; font-weight: bold; margin: 0;">Vehicle Detail : ${item.vehicleDetail}</p>
    //           <hr style="border-top: 1px dashed #000;"/>
    //           <div style="display: flex; justify-content: space-between;">
    //            <span><strong>Created Date:</strong></span>
    //            <span>${new Date(item.createdDate).toLocaleString("en-GB", {
    //                     month: "short",
    //                     day: "2-digit",
    //                     year: "numeric",
    //                     hour12: true,
    //                     hour: "numeric",
    //                     minute: "2-digit",
    //                   })}</span>
    //           </div>
    //           <hr style="border-top: 1px dashed #000;"/>
    //           <div style="display: flex;">
    //             <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Bill No.</p>
    //             <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Pcs</p>
    //             <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Garment</p>
    //             <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Job</p>
    //             <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">DD</p>
    //           </div>
    //           ${itemsHtml}
    //           <hr style="border-top: 1px dashed #000;"/>
    //           <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
    //         </div>
    //       </body>
    //     </html>
    //   `;
    //   await qz.print(config, [
    //     { type: "html", format: "plain", data: htmlContent },
    //   ]);
    //   // alert("HTML invoice sent to printer!");
    // } catch (err) {
    //   console.error("Print failed:", err);
    //   alert("Failed to print invoice");
    // }
  // };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Reports")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Report Collection Receipt
              </p>
            </div>
            {/*<div className="flex">
              <div className="mx-4 cursor-pointer" onClick={printHTML}>
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>*/}
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-8 ">
          <div className="flex justify-content-center flex-column print-section">
            <p className="text-2xl font-medium text-center line-height-2">
              Collection Report
            </p>
            <div className="flex justify-content-center align-items-center py-1">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-lg font-medium text-center line-height-2">
              {StoreName} - {searchFilterValue} - {new Date(receiptDate).toLocaleString("en-GB", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                  })}
            </p>
            <div className="flex justify-content-center align-items-center  py-1">
              <p className="w-5  border-dashed border-1 "></p>
            </div>

            <div style={{ marginLeft: 10, marginRight: 10 }}>
              {filteredDataInvoice.length > 0 && (
                <div>
                  <p className="text-lg font-medium line-height-2 py-1">
                    Order Report
                  </p>
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Bill No.
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Customer Name
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Amt
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Due
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Advance
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Todays Receipt
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDataInvoice.map((orderItem, orderIdx) => {
                        const particularLines = orderItem.collectionList.map(
                          (collection) =>
                            `${storeLocalData?.currencySymbol}${collection.amount} | ${
                              collection.paymentMode
                                ? collection.paymentMode.replace(
                                    "USER_ACCOUNT",
                                    "UA"
                                  )
                                : collection.paymentMode.replace(/_/g, " ")
                            }`
                        );

                        return (
                          <tr key={orderIdx}>
                            {/* Invoice No */}
                            <td className="border-1 px-2" style={{ width: 70 }}>
                              {orderItem.invoiceNo}
                            </td>
                            {/* Customer Name */}
                            <td
                              className="border-1 px-2"
                              style={{ width: 150 }}
                            >
                              {orderItem.customerName}
                            </td>
                            {/* Grand Total */}
                            <td className="border-1 px-2" style={{ width: 40 }}>
                              {storeLocalData?.currencySymbol}{orderItem.grandTotal}
                            </td>
                            {/* Due */}
                            <td className="border-1 px-2" style={{ width: 40 }}>
                              {storeLocalData?.currencySymbol}{orderItem.due}
                            </td>
                            {/* Advance */}
                            <td className="border-1 px-2" style={{ width: 40 }}>
                              {storeLocalData?.currencySymbol}{orderItem.advance}
                            </td>
                            {/* Today's Receipt (Particulars) */}
                            <td
                              className="border-1 px-2"
                              style={{ width: 120 }}
                            >
                              {particularLines.length > 0 ? particularLines.map((line, i) => (
                                <div key={i}>{line}</div>
                              )) : ""}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* Status Totals */}
                  <div className="flex pt-1">
                    {Object.entries(statusTotalData).map(([mode, amount]) => (
                      <div key={mode} className="px-1 py-2 border-round-md">
                        <p className="text-md font-medium">
                          {mode
                            ? mode.replace("USER_ACCOUNT", "UA")
                            : mode.replace(/_/g, " ")}
                          : {storeLocalData?.currencySymbol} {amount}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {filteredDataPackage.length > 0 && (
                <div>
                  <p className="text-lg font-medium line-height-2 py-1">
                    Package Report
                  </p>

                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Customer Name
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Package Name
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Todays Receipt
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDataPackage.map((orderItem, orderIdx) => {
                        // Build lines: first is customer name, rest are collection details
                        const particularLines = [
                          ...orderItem.collectionList.map(
                            (collection) =>
                              `${storeLocalData?.currencySymbol}${
                                collection.amount
                              } | ${collection.paymentMode.replace(/_/g, " ")}`
                          ),
                        ];

                        return (
                          <tr key={orderIdx}>
                            {/* Invoice No */}
                            <td className="border-1 px-2">
                              {orderItem.customerName}
                            </td>
                            {/* Advance */}
                            <td className="border-1 px-2">
                              {orderItem.subscriptionPackageInfo}
                            </td>
                            {/* Particulars Column: Customer + CollectionList lines */}
                            <td className="border-1 px-2">
                              {particularLines.map((line, i) => (
                                <div key={i}>{line}</div>
                              ))}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <div className="flex  pt-1">
                    {Object.entries(statusTotalPackageData).map(
                      ([mode, amount]) => (
                        <div
                          key={mode}
                          className="px-1 py-2 border-round-md ha"
                        >
                          <p className="text-md font-medium">
                            {mode.replace(/_/g, " ")}: {storeLocalData?.currencySymbol} {amount}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}

              {filteredDataWallet.length > 0 && (
                <div>
                  <p className="text-lg font-medium line-height-2 py-1">
                    Wallet Report
                  </p>

                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Customer Name
                        </th>
                        <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                          Todays Receipt
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDataWallet.map((orderItem, orderIdx) => {
                        // Build lines: first is customer name, rest are collection details
                        const particularLines = [
                          ...orderItem.collectionList.map(
                            (collection) =>
                              `${storeLocalData?.currencySymbol}${
                                collection.amount
                              } | ${collection.paymentMode.replace(/_/g, " ")}`
                          ),
                        ];

                        return (
                          <tr key={`order-${orderIdx}`}>
                            {/* Customer Name */}
                            <td className="border-1 px-2">
                              {orderItem.customerName}
                            </td>
                            <td className="border-1 px-2">
                              {particularLines.map((line, i) => (
                                <div key={i}>{line}</div>
                              ))}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <div className="flex   pt-1">
                    {Object.entries(statusTotalWalletData).map(
                      ([mode, amount]) => (
                        <div key={mode} className="px-1 py-2 border-round-md">
                          <p className="text-md font-medium">
                            {mode.replace(/_/g, " ")}: {storeLocalData?.currencySymbol} {amount}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}

              <p className="text-lg font-medium line-height-2 py-1">
                Payment Summary
              </p>

              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                      Payment Mode
                    </th>
                    <th className="text-md font-semibold text-left border-1 px-2 line-height-3">
                      Amount
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(allTotalData).map(([mode, amount]) => (
                    <tr>
                      <td className="text-md font-normal text-left border-1 px-2 line-height-3">
                        {mode.replace(/_/g, " ")}
                      </td>
                      <td className="text-md font-normal text-left border-1 px-2 line-height-3">
                        {storeLocalData?.currencySymbol} {amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="text-2xl font-medium text-center">
                Powered By {brand.name}
              </p>
            </div>
          </div>
        </div>

        <div className="mx-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>
      </div>

      {/* Menu component */}
      {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" || userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
      <ButtonLink />
        <StoreMenu setVisible={setVisible} visible={visible} />
        </>
      )}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
              @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default StoreReportCollectionReceipt;
